export const animationModules = [
  {
    selector: '.js-testimonials-block',
    importer: () => import('./testimonials'),
  },
  {
    selector: '.js-highlight-block',
    importer: () => import('./highlight'),
  },
  {
    selector: '.js-text-image-split-block',
    importer: () => import('./textImageSplit'),
  },
  {
    selector: '.js-statistics-block',
    importer: () => import('./statistics'),
  },
  {
    selector: '.js-three-cta-cards-block',
    importer: () => import('./threeCtaCards'),
  },
  {
    selector: '.js-hub-categories-block',
    importer: () => import('./hubCategories'),
  },
];
